import { DpCheckbox } from '@/components/blocks/DpCheckbox';
import { Img } from '@/components/blocks/MaterialImage';
import { OutfitItemPrice } from '@/components/blocks/ModalOutfits/parts/OutfitItem/parts/OutfitItemPrice';
import { RenderProductImg } from '@/components/blocks/RenderProductImg';
import { Box, Typography, Stack } from '@mui/material';
import { OutfitItemSize } from '@/components/blocks/ModalOutfits/parts/OutfitItem/parts/OutfitItemSize';
import { ProductType } from '@/data/types/Product';
import { useModalOutfitsContext } from '@/components/blocks/ModalOutfits/parts/OutfitsProvider';
import { Linkable } from '@/components/blocks/Linkable';

interface OutfitItemProps {
	product: ProductType & { sizes: { partNumber: string; size: string }[] };
}

export const OutfitItem: React.FC<OutfitItemProps> = ({ product }) => {
	const { productsSelected, onToggleCheckProduct } = useModalOutfitsContext();

	const isChecked = !!Object.keys(productsSelected).includes(product.partNumber);

	const handleOnToggleCheckProduct = () => {
		onToggleCheckProduct(product.partNumber);
	};

	return (
		<Stack direction="row" alignItems="center" spacing={2} my={2}>
			<DpCheckbox checked={isChecked} onChange={handleOnToggleCheckProduct} />
			<RenderProductImg
				fullImageRaw={product.thumbnail}
				render={(img) => (
					<Linkable href={product.seo.href}>
						<Img src={img} alt={product.name} sx={{ width: '84px', height: '84px' }} />
					</Linkable>
				)}
			/>
			<Box
				sx={{
					flex: 1,
					display: 'flex',
					flexDirection: 'column',
					minHeight: '64px',
					gap: '8px',
				}}
			>
				<Linkable href={product.seo.href}>
					<Typography
						sx={{
							color: '#313131',
							fontWeight: 600,
							fontSize: '14px',
						}}
					>
						{product.name}
					</Typography>
				</Linkable>
				<Stack direction="row" justifyContent="space-between" alignItems="flex-start">
					<OutfitItemPrice product={product} />
					<OutfitItemSize product={product} />
				</Stack>
			</Box>
		</Stack>
	);
};
